import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { RouterExtensionService } from '../../core/services/router-extension.service';
import { PreviousUrlModel } from '../../shared/router-extension.model';
import { CustomerService } from '../../core/services/customer.service';
import { NotificationService } from '../../core/services/notification.service';

@Component({
    selector: 'app-forgot-password-form',
    templateUrl: './forgot-password-form.component.html',
    styleUrls: ['./forgot-password-form.component.scss'],
    standalone: false
})
export class ForgotPasswordFormComponent implements OnInit {
  @Input() email: string;
  previousUrl = new PreviousUrlModel();

  forgotPasswordForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private routerExtensionService: RouterExtensionService,
    private customerService: CustomerService,
    private notificationService: NotificationService,
    private router: Router
  ) {
    this.routerExtensionService.previousUrlSubject.subscribe(previousUrl => {
      this.previousUrl.url = previousUrl ? previousUrl.url : ['/store'];
      this.previousUrl.paramMap = previousUrl ? previousUrl.paramMap : {};
    });

    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit() {
    if (this.email) {
      this.forgotPasswordForm.patchValue({email: this.email});
    }
  }

  submit () {
    if (!this.forgotPasswordForm.invalid) {
      this.customerService.forgotPassword({ email: this.forgotPasswordForm.value.email }).subscribe(res => {
        if (res && res.id && res.type !== 'guest') {
          this.notificationService.broadcastSuccessNotification({
            message:`An email to reset your password has been sent to ${this.forgotPasswordForm.value.email}.`,
          });
          this.router.navigate(['/store']);
        } else {
          this.notificationService.broadcastFailureNotification({
            message:`Email not recognized.`,
          });
          this.router.navigate(['/register']);
        }
      });
    }
  }
}